import { applyCustomTheme, CustomThemeSet } from '@vimeo/bifrost/themes';
import { bokehTheme as theme } from '@vimeo/bokeh-theme';

interface CustomTheme {
  elements: {
    bg0: string;
    bg1: string;
    color0: string;
    color1: string;
    color2: string;
    color3: string;
    color4: string;
    color5: string;
    color6: string;
  };
  icons: {
    fill0: string;
  };
}

export const customThemes: CustomThemeSet<CustomTheme> = {
  light: {
    elements: {
      bg0: theme.colors.gray['50'] as string,
      bg1: theme.colors.white as string,
      color0: theme.colors.gray['100'] as string,
      color1: theme.colors.gray['200'] as string,
      color2: theme.colors.gray['800'] as string,
      color3: theme.colors.gray['800'] as string,
      color4: theme.colors.gray['200'] as string,
      color5: theme.colors.gray['300'] as string,
      color6: theme.colors.gray['100'] as string,
    },
    icons: {
      fill0: theme.colors.gray['200'] as string,
    },
  },
  dark: {
    elements: {
      bg0: theme.colors.gray['700'] as string,
      bg1: theme.colors.gray['800'] as string,
      color0: theme.colors.gray['600'] as string,
      color1: theme.colors.gray['400'] as string,
      color2: theme.colors.gray['100'] as string,
      color3: theme.colors.white as string,
      color4: theme.colors.gray['600'] as string,
      color5: theme.colors.gray['200'] as string,
      color6: theme.colors.gray['700'] as string,
    },
    icons: {
      fill0: theme.colors.gray['200'] as string,
    },
  },
};

export const applyCustomThemeEssentialFooter = applyCustomTheme(customThemes);
